module.exports = __webpack_public_path__ + "static/media/img-hero-section.90a509b0.png";